// maskDirective.js
const customMask = function(el, binding) {
  const self = this;

  this.init = function(el, binding) {
    if(binding.value === undefined) {
      //console.warn('Diretiva de máscara: valor não definido. A máscara não será aplicada.');
      return;
    }

    el._binding = binding;

    // Configuração inicial
    el._maskHandler = (event) => self.handleMaskInput(event, binding);
    el.addEventListener('input', el._maskHandler);
    el.addEventListener('keydown', (e) => self.handleBackspace(e, el, binding));

    // Armazena o último valor para comparação
    el._lastValue = '';
  };

  this.handleMaskInput = function(event, binding) {
    const input = event.target;

    // Evita recursão comparando com o último valor
    if (input._lastValue === input.value) return;

    // Obtém as máscaras possíveis
    const masks = Array.isArray(binding.value) ? binding.value : [binding.value];

    // Remove todos os caracteres não numéricos
    const rawValue = input.value.replace(/\D/g, '');

    // Encontra a máscara que melhor se adapta
    const bestMask = self.findBestMask(rawValue, masks);

    if (!bestMask) {
      self.updateInputValue(input, rawValue);
      return;
    }

    // Aplica a máscara selecionada
    const maskedValue = self.applyMask(rawValue, bestMask);

    // Atualiza o valor apenas se for diferente
    if (input.value !== maskedValue) {
      self.updateInputValue(input, maskedValue);
    }
  };

  this.findBestMask = function(rawValue, masks) {
    // Ordena as máscaras pelo tamanho (maior primeiro)
    const sortedMasks = [...masks].sort((a, b) => {
      const countA = (a.match(/#/g) || []).length;
      const countB = (b.match(/#/g) || []).length;
      return countA - countB;
    });

    // Encontra a primeira máscara que o valor cru pode preencher
    for (const mask of sortedMasks) {
      const maskDigitCount = (mask.match(/#/g) || []).length;
      if (rawValue.length <= maskDigitCount) {
        return mask;
      }
    }

    return sortedMasks[0] || null;
  };

  this.applyMask = function(value, mask) {
    let valueIndex = 0;
    let formattedValue = '';

    for (let i = 0; i < mask.length; i++) {
      if (mask[i] === '#') {
        if (valueIndex < value.length) {
          formattedValue += value[valueIndex++];
        } else {
          break;
        }
      } else {
        if (valueIndex > 0 || i === 0) {
          formattedValue += mask[i];
        }
      }
    }

    return formattedValue;
  };

  this.handleBackspace = function(event, el, binding) {
    if (event.key === 'Tab') {
      return;
    }
    if (event.key !== 'Backspace') {
      const masks = Array.isArray(binding.value) ? binding.value : [binding.value];
      masks.sort((a, b) => {
        return b.length - a.length;
      });

      if(masks[0].length <= event.target.value.length) {
        event.preventDefault();
        event.stopPropagation();
      }

      return;
    }


    const input = event.target;

    // Se o cursor estiver no final, não faz nada especial
    if (input.selectionStart !== input.selectionEnd ||
        input.selectionStart !== input.value.length) {
      return;
    }

    // Verifica se o último caractere é não numérico
    const lastChar = input.value.slice(-1);
    if (/\D/.test(lastChar)) {
      // Previne o comportamento padrão e remove o último caractere não numérico
      event.preventDefault();
      self.updateInputValue(input, input.value.slice(0, -1));
    }
  };

  this.updateInputValue = function(input, newValue) {
    // Atualiza o valor e armazena o último valor
    input.value = newValue;
    input._lastValue = newValue;

    // Dispara o evento manualmente sem causar recursão
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value'
    ).set;

    nativeInputValueSetter.call(input, newValue);

    const event = new Event('input', { bubbles: true });
    input.dispatchEvent(event);
  };

  self.init(el, binding);
};


function mask(selector, maskPattern) {
  const input = document.querySelectorAll(selector);
  if (!input) return;
  input.forEach((el) => {
    if(!maskPattern) {
      maskPattern = el.dataset.mask;
    }

    new customMask(el, { value: maskPattern });
  });
}

export default mask;
